module.exports = __webpack_public_path__ + "img/zone_manager.1baa2933.png";